import styled from 'styled-components';

import { colors } from '@soluto-private/mx-asurion-ui-react';

export const HorizontalRule = styled.hr`
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid ${colors.neutralBrighter};
  margin: 0;
  padding: 0;
`;
